import { QUESTIONS_ANSWERED_DISPLAY } from "../constants/publicMetrics";
import React from "react";
import appStoreBadge from "../assets/app-store-badge.svg";
import { APP_STORE_URL } from "../constants/productLinks";
import HeroTestimonials from "./HeroTestimonials";
import { validateHomepageFeedback, draftHomepageFeedback } from "./HomeHeroFeedback";
import { feedbackApi, useHomepageResource } from "../hooks/useHomepageResource";
import styles from "./HomeHeroDemo.module.css";

import ksuLogo from "../assets/workLocations_logos/ksu_logo_monochrome.png";
import ksauHsLogo from "../assets/workLocations_logos/ksau_hs_logo.png";
import aljoufLogo from "../assets/workLocations_logos/aljouf_university_logo_transparent.png";
import qassimLogo from "../assets/workLocations_logos/qassim_university_logo.svg";
import kauLogo from "../assets/workLocations_logos/kau_logo_highres.png";
import pnuLogo from "../assets/workLocations_logos/pnu_logo_icon.svg";

// Reuse the university names and assets already shown on the original homepage.
const universities = [
  { name: "KSAU-HS", logo: ksauHsLogo, seal: true },
  { name: "Al Jouf University", logo: aljoufLogo },
  { name: "King Saud University", logo: ksuLogo },
  { name: "Qassim University", logo: qassimLogo },
  { name: "Princess Nourah University", logo: pnuLogo, seal: true },
  { name: "King Abdulaziz University", logo: kauLogo, seal: true },
];

export default function HomeHeroDemo() {
  const resource = useHomepageResource(`${feedbackApi}/api/feedback?approved=true&limit=12`, validateHomepageFeedback);
  const preferredAuthors = ["Jumana", "Shaima"];
  const source = process.env.NODE_ENV === "development" ? draftHomepageFeedback : resource.data || [];
  const priority = (name: string | null) => { const index = preferredAuthors.indexOf(name || ""); return index < 0 ? preferredAuthors.length : index; };
  const feedback = [...source].sort((a, b) => priority(a.name) - priority(b.name)).slice(0, 2);
  return <div className={styles.composition}>
    <div className={styles.feedback}><HeroTestimonials feedback={feedback} /></div>
    <ul className={styles.universityLogos} aria-label="University logos">
      {universities.map(university => <li key={university.name}>
        <img src={university.logo} alt={university.name} className={university.seal ? styles.universitySeal : undefined} draggable={false} />
      </li>)}
    </ul>
    <div className={styles.trust} aria-label="Our learning community">
      <p><strong>{QUESTIONS_ANSWERED_DISPLAY}</strong><span>questions answered</span></p>
      <p><strong>1,400+</strong><span>dental professionals</span></p>
      <p><strong>17,000+</strong><span>QBank uses</span></p>
    </div>
    <div className={styles.appStore}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" aria-label="Download C-Shaped on the App Store">
        <img src={appStoreBadge} alt="Download on the App Store" width="162" height="48" />
      </a>
    </div>
  </div>;
}
